<template>
  <div class="c-toggle-list__panel">
    <div class="c-toggle-list__inner">
      <div class="c-toggle-list__panel-content">
        <img
          class="c-toggle-list__panel-icon"
          v-if="icon"
          :src="icon"
          alt=""
        />
        <h3 class="c-toggle-list__title">{{ title }}</h3>
      </div>
      <label v-if="this.configurable" class="c-toggle-list__toggle" :for="title" :aria-label="title">
        <input :id="title" type="checkbox" v-on:click="buttonState" :checked="state" />
        <span class="c-toggle-list__slider"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "MapTogglePanel",
  props: ["configurable", "icon", "refId", "state", "title"],
  methods: {
    buttonState() {
      if (this.state) {
        this.$emit("onToggleChecked", this.refId);
      } else {
        this.$emit("onToggleDisabled", this.refId);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/layered-map/MapTogglePanel.vue